// extracted by mini-css-extract-plugin
export default {"card":"InfoCard_card__bYDT1","card_title":"InfoCard_card_title__4RBD4","card_value":"InfoCard_card_value__kuwcS","spin":"InfoCard_spin__9in8K"};